﻿import $ from 'jquery';
import { Age } from "../utilities/age";
import _ from 'underscore';

export class AgeField {
  public static wireupDocument: Function = _.once(() => {
    $(document).on('change.rustig', '[data-birthdate]', function () {
      try {
        let inputValue = $(this).val() as string;
        var ageValue = null;
        var birthdate = new Date(inputValue);
        var isValid = !isNaN(birthdate.getTime()) && birthdate.getFullYear() > 1800;
        if (isValid)
          ageValue = new Age(birthdate).Years.toString();

        $('[data-age]').val(ageValue);
      }
      catch (e) { }

    });
  });
}

